import React, { useState, useEffect } from 'react';
import CheckboxField from './CheckboxField';
import RangeField from './RangeField';
import IconsField from './IconsField';
import FeaturesField from './FeaturesField';

const QuizComponent = ({ data }) => {
  const [slide, setSlide] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [rangeValues, setRangeValues] = useState({});

  const initialFormState = data.questions.reduce((acc, question) => {
    acc[question.field] = [];
    return acc;
  }, { name: '', email: '' });

  const [form, setForm] = useState(initialFormState);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckboxChange = (field, value) => {
    setForm(prevForm => ({
      ...prevForm,
      [field]: prevForm[field].includes(value)
        ? prevForm[field].filter(v => v !== value)
        : [...prevForm[field], value]
    }));
  };

  const handleNext = () => {
    setSlide(slide + 1);
  };

  const handleBack = () => {
    setSlide(slide - 1);
  };

  const handleRestart = () => {
    setSlide(0);
    setForm(initialFormState);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const link = prepareLink(form);
    redirect(link);
  };

  const handleSubmitLead = (e) => {
    e.preventDefault();
    const link = prepareLink(form);
    submitLead(form.name, form.email, () => {
      redirect(link);
    });
  };



  const prepareLink = (form) => {
    const urlData = { ...form };
    delete urlData.name;
    delete urlData.email;
    if(urlData.price) {
      urlData.price = JSON.stringify(urlData.price);
    }
    const data = resolveData(urlData); // TODO: here
    return new URLSearchParams(data).toString();
  };

  const resolveData = (data) => {
    const serialized = JSON.stringify(data);
    return JSON.parse(serialized);
  };

  const submitLead = (name, email, cb) => {
    fetch('/wp-admin/admin-ajax.php?action=add_lead', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ name: name, email: email, formid: data.lead.gravity_form_id })
    })
      .then(response => response.json())
      .then(() => cb())
      .catch(error => console.error('Error:', error));
  };

  const redirect = (link) => {
    window.location.href = `/database?${link}`;
  };

  const renderField = (question) => {
    switch (question.type) {
      case 'checkboxes':
        return (
          <CheckboxField
            key={question.field}
            field={question}
            updateGlobalFilter={handleChange}
            componentClass='grid grid-cols-2 text-lg leading-8'
          />
        );
      case 'range':
        return (
          <RangeField
            key={question.field}
            field={question}
            rangeValues={rangeValues}
            setRangeValues={setRangeValues}
            updateGlobalFilter={handleChange}
          />
        );
      case 'icons':
        return (
          <IconsField
            key={question.field}
            field={question}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            updateGlobalFilter={handleChange}
          />
        );
      case 'features':
        return (
          <FeaturesField
            key={question.field}
            field={question}
            updateGlobalFilter={handleChange}
            componentClass='grid grid-cols-2 text-lg leading-6'
          />
        );
      default:
        return null;
    }
  };

  const currentQuestion = data.questions[slide];

  return (
    <main id="primary">
      <div id="intro" className={`${slide === 0 ? '' : 'hidden'}`}>
        <div className="md:grid md:grid-cols-2 gap-6">
          <div className="container max-w-screen-sm ml-auto mr-0 px-8 py-8 md:px-16 md:py-32">
            <div className="text-black text-4xl mb-6 font-headings font-bold text-center md:text-left">{data.intro.title}</div>
            <p className="text-black text-xl mb-8 max-w-2xl">{data.intro.text}</p>
            <div>
              <button onClick={handleNext} className="btn hover:btn-hover active:btn-active my-2 w-full text-center md:w-auto">{data.intro.button_text}</button>
            </div>
          </div>
          <div className="bg-cover hero bg-center" style={{ backgroundImage: `url(${data.intro.background})` }}></div>
        </div>
      </div>

      {data.questions.map((question, index) => (
        <div key={index} id={`question${index + 1}`} className={`${slide === index + 1 ? '' : 'hidden'}`}>
          <div className="md:grid md:grid-cols-2 gap-6">
            <div className="container max-w-screen-sm ml-auto mr-0 p-8 md:py-16 md:px-4">
              <div className="flex justify-between mb-8">
                <p className="opacity-80">Question <strong>{index + 1}</strong>/{data.questions.length}</p>
                <a href="#" onClick={handleRestart} className="block text-sky font-bold">Restart Quiz</a>
              </div>
              <div className="text-black text-4xl mb-6 font-headings font-bold">{question.title}</div>
              <p className="text-black text-xl mb-6 max-w-2xl">{question.text}</p>
              {renderField(question)}
              <div className="mb-4">
                <button onClick={() => { handleCheckboxChange(question.field, []); handleNext() }} className="text-lg font-bold text-sky">{question.button_text}</button>
              </div>

              <div className="mb-4 flex justify-end items-end ">
                {index > -1 && <button onClick={handleBack} className="p-4 text-center my-2 mr-4 w-full text-cr-selection md:w-auto inline-flex">
                  <img
                    class="h-6 mr-2"
                    src="/wp-content/themes/cr2021/images/icons/arrow-gray.svg"
                    alt="->" />
                  Back
                </button>}

                <button onClick={handleNext} className="btn hover:btn-hover active:btn-active text-center my-2 w-full md:w-auto inline-flex">
                  Next
                  <img
                    class="h-6 mt-1 ml-2"
                    src="/wp-content/themes/cr2021/images/icons/arrow-black.svg"
                    alt="->" />
                </button>
              </div>

            </div>
            <div className="bg-cover hero bg-center" style={{ backgroundImage: `url(${question.background})` }}></div>
          </div>
        </div>
      ))}

      <div id="lead" className={`${slide === data.questions.length + 1 ? '' : 'hidden'}`}>
        <div className="md:grid md:grid-cols-2 gap-6">
          <form className="container max-w-screen-sm ml-auto mr-0 p-8 md:p-16">
            <p className="opacity-80 mb-8"></p>
            <div className="text-black text-4xl mb-6 font-headings font-bold">{data.lead.title}</div>
            <p className="text-black text-xl mb-6 max-w-2xl">{data.lead.text}</p>


            <div className="mb-6">
              <div className="max-w-md">
                <div className="mb-4">
                  <label htmlFor="name" className="block text-sm text-gray-700 -mb-2 ml-4 z-10 relative">Name<span className="text-radish">*</span></label>
                  <input type="text" name="name" className="block w-full px-8 py-4 rounded-lg bg-gray-200 outline-none" value={form.name} onChange={(e) => handleChange('name', e.target.value)} />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm text-gray-700 -mb-2 ml-4 z-10 relative">Email<span className="text-radish">*</span></label>
                  <input type="text" name="email" className="block w-full px-8 py-4 rounded-lg bg-gray-200 outline-none" value={form.email} onChange={(e) => handleChange('email', e.target.value)} />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <button type="submit" onClick={handleSubmitLead} className="btn hover:btn-hover active:btn-active my-2">{data.lead.yes_button}</button>
            </div>

            <p className="mb-4 text-sm text-gray-700 px-2">{data.lead.privacy_notice}</p>
            <button onClick={handleSubmit} className="text-skye font-bold mx-2">{data.lead.no_button}</button>
          </form>
          <div className="bg-cover hero bg-center" style={{ backgroundImage: `url(${data.lead.background})` }}></div>
        </div>
      </div>
    </main>
  );
};

export default QuizComponent;